export default "__VITE_ASSET__rd4Wt4xH__"